"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Exports_1 = require("./Exports");
var GlobalContext_1 = require("../../../Context/GlobalContext");
var DashboardPage = /** @class */ (function (_super) {
    __extends(DashboardPage, _super);
    function DashboardPage(props) {
        return _super.call(this, props) || this;
    }
    DashboardPage.prototype.render = function () {
        var _this = this;
        return (React.createElement(GlobalContext_1.GlobalConsumer, null, function (context) { return context && (React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-8" },
                React.createElement(Exports_1.DashboardNavBar, { resources: _this.props.resources, applicationData: context }),
                React.createElement(Exports_1.DashboardContentArea, { title: _this.props.title }, _this.props.content)),
            React.createElement("div", { className: "col-4" },
                React.createElement(Exports_1.DashboardPanel, { applicationData: context, actions: _this.props.actions, placeholder: _this.props.placeholder })))); }));
    };
    return DashboardPage;
}(React.Component));
exports.DashboardPage = DashboardPage;
//# sourceMappingURL=DashboardPage.js.map